





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';
import Integrations from '@/components/Integrations/Integrations.vue';


@Component({
	name: 'IntegrationSettings',
  	components: { Integrations, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getIntegrations();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingIntegrations;
  	}
}
